import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_METRICS_AVAILABILITY,
  GET_AZURE_METRICS_AVAILABILITY_SUCCESS,
  GET_AZURE_METRICS_AVAILABILITY_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureMetricsAvailabilityList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureMetricsAvailabilityStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_METRICS_AVAILABILITY:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_METRICS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureMetricsAvailabilityList: action.data,
        error: null,
      };
    case GET_AZURE_METRICS_AVAILABILITY_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
